(function () {
  'use strict';
  if (window.SugarAnalytics) return;

  var DEFAULT_ENDPOINT = 'https://app.sugarwords.ai/api/t';
  var MAX_BATCH = 25;

  function endpoint() {
    try {
      return localStorage.getItem('_sugar_ep') || DEFAULT_ENDPOINT;
    } catch (e) {
      return DEFAULT_ENDPOINT;
    }
  }

  function randomHex(len) {
    var out = '';
    try {
      var bytes = new Uint8Array(len / 2);
      crypto.getRandomValues(bytes);
      for (var i = 0; i < bytes.length; i++) out += (bytes[i] + 256).toString(16).slice(1);
    } catch (e) {
      while (out.length < len) out += Math.random().toString(16).slice(2);
    }
    return out.slice(0, len);
  }

  function visitorId() {
    try {
      var vid = localStorage.getItem('_sugar_vid');
      if (!vid || !/^[a-f0-9]{8,32}$/.test(vid)) {
        vid = randomHex(16);
        localStorage.setItem('_sugar_vid', vid);
      }
      return vid;
    } catch (e) {
      return randomHex(16);
    }
  }

  var vid = visitorId();
  var queue = [];
  var flushTimer = null;

  function flush() {
    if (!queue.length) return;
    if (window.__swOk === false) {
      queue = [];
      return;
    }
    var shop = (window.Shopify && window.Shopify.shop) || '';
    if (!shop) {
      queue = [];
      return;
    }
    while (queue.length) {
      var batch = queue.splice(0, MAX_BATCH);
      var payload = JSON.stringify({ shop: shop, vid: vid, events: batch });
      var sent = false;
      try {
        sent = navigator.sendBeacon(endpoint(), new Blob([payload], { type: 'text/plain' }));
      } catch (e) {
        sent = false;
      }
      if (!sent) {
        try {
          fetch(endpoint(), {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain' },
            body: payload,
            keepalive: true
          }).catch(function () {});
        } catch (e) {
          // network unavailable; drop batch
        }
      }
    }
  }

  function track(type, kind, entityId, detail, ctx) {
    if (!entityId) return;
    queue.push({
      t: String(type),
      k: String(kind || 'offers'),
      e: String(entityId),
      v: detail == null ? '' : String(detail),
      ts: Date.now(),
      ctx: ctx || {}
    });
    if (type === 'atc') setTimeout(function () { syncCartAttributes(true); }, 400);
    if (queue.length >= 20) {
      flush();
      return;
    }
    clearTimeout(flushTimer);
    flushTimer = setTimeout(flush, 3000);
  }

  function sessionOnce(key) {
    try {
      if (sessionStorage.getItem(key)) return false;
      sessionStorage.setItem(key, '1');
      return true;
    } catch (e) {
      return true;
    }
  }

  function observe(el, entityId, kind, ctx) {
    if (!el || !entityId) return;
    try {
      if (sessionStorage.getItem('_sugar_imp_' + entityId)) return;
    } catch (e) {
      // fall through; sessionOnce below still dedupes best-effort
    }
    if (!('IntersectionObserver' in window)) {
      if (sessionOnce('_sugar_imp_' + entityId)) track('impression', kind, entityId, '', ctx);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          io.disconnect();
          if (sessionOnce('_sugar_imp_' + entityId)) track('impression', kind, entityId, '', ctx);
          return;
        }
      },
      { threshold: 0.5 }
    );
    io.observe(el);
  }

  function abAssignments() {
    try {
      var parsed = JSON.parse(localStorage.getItem('_sugar_ab') || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function abAssign(testId, splitPercentA) {
    var assignments = abAssignments();
    var current = assignments[testId];
    if (current === 1 || current === 2) return current;
    var split = parseInt(splitPercentA, 10);
    if (!(split >= 0 && split <= 100)) split = 50;
    var variant = Math.random() * 100 < split ? 1 : 2;
    assignments[testId] = variant;
    try {
      localStorage.setItem('_sugar_ab', JSON.stringify(assignments));
    } catch (e) {
      // assignment stays for this page only
    }
    return variant;
  }

  function syncCartAttributes(force) {
    if (window.__swOk === false) return;
    var assignments = abAssignments();
    var serialized = JSON.stringify(assignments);
    if (!force) {
      try {
        if (sessionStorage.getItem('_sugar_ca_synced') === serialized) return;
      } catch (e) {
        // no sessionStorage; sync anyway
      }
    }
    var attrs = { _sugar_vid: vid };
    if (Object.keys(assignments).length) attrs._sugar_ab = serialized;
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function (r) {
        if (r.ok) {
          try { sessionStorage.setItem('_sugar_ca_synced', serialized); } catch (e) {}
        }
      }).catch(function () {});
    } catch (e) {
      // ignore
    }
  }

  window.SugarAnalytics = {
    track: track,
    observe: observe,
    flush: flush,
    sessionOnce: sessionOnce,
    abAssign: abAssign,
    abAssignments: abAssignments,
    syncAbCartAttribute: syncCartAttributes,
    syncCartAttributes: syncCartAttributes,
    vid: vid
  };

  // Drain events queued by inline scripts that ran before this file loaded.
  var pre = window._sugarQ;
  if (pre && pre.length) {
    for (var i = 0; i < pre.length; i++) {
      var item = pre[i];
      if (item && item.length) track(item[0], item[1], item[2], item[3], item[4]);
    }
  }
  window._sugarQ = { push: function (item) { if (item && item.length) track(item[0], item[1], item[2], item[3], item[4]); } };

  if (window._sugarAbOnPage) syncCartAttributes();

  // Per-page analytics: only templates with a custom suffix are tracked.
  var body = document.body;
  var pageTemplate = (body && body.getAttribute('data-sugar-template')) || '';
  var pageSuffix = (body && body.getAttribute('data-sugar-template-suffix')) || '';
  if (pageTemplate && pageSuffix) {
    var pageCtx = { template: pageTemplate, path: window.location.pathname };
    track('pv', 'page', pageTemplate, '', pageCtx);
    syncCartAttributes();

    var maxDepth = 0;
    var depthSent = false;
    var measureDepth = function () {
      var doc = document.documentElement;
      var total = Math.max(doc.scrollHeight, 1);
      var seen = Math.min(total, (window.scrollY || doc.scrollTop || 0) + window.innerHeight);
      var pct = (seen / total) * 100;
      if (pct > maxDepth) maxDepth = pct;
    };
    var sendDepth = function () {
      if (depthSent) return;
      depthSent = true;
      measureDepth();
      var bucket = maxDepth >= 90 ? '100' : maxDepth >= 75 ? '75' : maxDepth >= 50 ? '50' : '25';
      track('scroll', 'page', pageTemplate, bucket, pageCtx);
      flush();
    };
    measureDepth();
    window.addEventListener('scroll', measureDepth, { passive: true });
    window.addEventListener('pagehide', sendDepth);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') sendDepth();
    });

    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest && e.target.closest('[data-sugar-cta]');
      if (!el) return;
      var href = el.getAttribute('href') || '';
      var dest = href;
      try { dest = new URL(href, window.location.origin).pathname; } catch (err) {}
      track('click', 'page', pageTemplate, dest, {
        template: pageTemplate,
        path: window.location.pathname,
        label: (el.textContent || '').trim().slice(0, 80)
      });
      flush();
    }, true);
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
  });
  window.addEventListener('pagehide', flush);

  document.dispatchEvent(new CustomEvent('sugar:analytics:ready'));
})();
